module.exports = __webpack_public_path__ + "assets/img/6_608.c630a932.jpg";